$(document).ready(function(){
  
  //modified in launch.js instead
  //if (window.location.hash === '#recover') {
  //  this.recoverPassword();
  //}

  //Check if token is being set
  
  if (window.location.href.indexOf('/account') > -1){
    const queryString = window.location.search;
    console.log(queryString);
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('token')) {
      const token = urlParams.get('token');
      console.log(token);
      setCookie('token',token);
    }
  }



  
  $("p").click(function(){
    ////$("#loginBtn").hide();
    //$(this).hide();
  });
  $("#namaPinCode").mousedown(function(){
    //$(this).hide();
    $(this).text($(this).data('password'));
  });
  $("#namaPinCode").mouseup(function(){
    //$(this).hide();
    $(this).text("****");
  });
  
  $("#namaPinCodeChange").click(function(){
    $(this).hide();
    $("#namaPinCode").hide();
    $("#namaPinCodeSet").show();
    $("#namaPinCodeSave").show();
    $("#namaPinCodeCancelChange").show();
    return false;
  });  
  $("#namaPinCodeCancelChange").click(function(){
    $(this).hide();
    $("#namaPinCodeSet").hide();
    $("#namaPinCodeSave").hide();
    $("#namaPinCode").show();
    $("#namaPinCodeChange").show();
    return false;
  });
  $("#namaPinCodeSave").click(function(){
    $(this).hide();
    $("#namaPinCodeSet").hide();
    $("#namaPinCodeCancelChange").hide();
    $("#namaPinCode").show();
    $("#namaPinCodeChange").show();

//

    //$.post("https://negah.iranproud2.net/api/shopifycustomerpinchange",
    //$.post("https://negah.negahestan.com/api/shopifycustomerpinchange",
    $.post("https://negahold.negahestan.com/api/shopifycustomerpinchange",
    {
      id: window.ShopifyAnalytics.meta.page.customerId,
      tags: $("#namaPinCodeSet").val()
    },
    function(data, status){
      alert("Status: " + status);
      //alert("Data: " + data + "\nStatus: " + status);
    });
    
//    $.post("https://namakadeh.myshopify.com/admin/api/2023-04/customers/" + window.ShopifyAnalytics.meta.page.customerId + ".json",
//    {
//      note: "666",
//      tags: "666"
//    },
//    function(data, status){
//      alert("Status: " + status);
//      alert("Data: " + data + "\nStatus: " + status);
//    });


//    $.ajax({
//        type: "PUT",
//        url: "https://namakadeh.myshopify.com/admin/api/2023-04/customers/" + window.ShopifyAnalytics.meta.page.customerId + ".json?tags=" + "555" ,
//        success: function(response) {
//            alert("Status: " + response);
//        },                                      
//        error: function(e) {            
//            alert("Error: " + e);                          
//       }                
//    });

  });
  

  // Below two blocks are to adjust checkout button from sending to a translated page
  if (window.location.href.indexOf('/cart') > -1){
    var ff = document.getElementById("cartForm");
    if (ff != undefined){
        if (ff.action.indexOf('?locale=fa') > -1){
          debugger;
            ff.action = ff.action.replace('?locale=fa','?locale=en');
        }
        else{
            const targetNodeInt = document.getElementById("cartForm");
            const configInt = {attributes: true, childList: true, subtree: true };
            
            const callbackInt = function(mutationsList, observer) {
                debugger;
                for(let mutation of mutationsList) {
                    if (mutation.type === 'attributes') {
                      var ff = document.getElementById("cartForm");
                      if (ff != undefined){
                        if (ff.action.indexOf('?locale=fa') > -1){
                            ff.action = ff.action.replace('?locale=fa','?locale=en');
                        }
                      }
                    }
                }
            };
            const observerInt = new MutationObserver(callbackInt);
            observerInt.observe(targetNodeInt, configInt);
        }
    }
  }
  if (window.location.href.indexOf('/products/') > -1){
    const targetNode = document.getElementById("product-cart-message_Holder");
    const config = {childList: true, subtree: true };
    
    const callback = function(mutationsList, observer) {
        debugger;
        for(let mutation of mutationsList) {
            if (mutation.type === 'childList') {
              var ff = document.getElementById("cartForm");
              if (ff != undefined){
                if (ff.action.indexOf('?locale=fa') > -1){
                  debugger;
                    ff.action = ff.action.replace('?locale=fa','?locale=en');
                }
                else{
                    const targetNodeInt = document.getElementById("cartForm");
                    const configInt = {attributes: true, childList: true, subtree: true };
                    
                    const callbackInt = function(mutationsList, observer) {
                        debugger;
                        for(let mutation of mutationsList) {
                            if (mutation.type === 'attributes') {
                              var ff = document.getElementById("cartForm");
                              if (ff != undefined){
                                if (ff.action.indexOf('?locale=fa') > -1){
                                    ff.action = ff.action.replace('?locale=fa','?locale=en');
                                }
                              }
                            }
                        }
                    };
                    const observerInt = new MutationObserver(callbackInt);
                    observerInt.observe(targetNodeInt, configInt);
                }                
              }
            }
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
  
});

  function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }
  function deleteCookie(cname) {
      document.cookie = cname + "=" + ";" + " expires=Thu, 01 Jan 1970 00:00:00 UTC;" + ";path=/";
  }
  function getCustomerId() {
    try {
      let curr = window.ShopifyAnalytics.meta.page.customerId;
      if (curr !== undefined && curr !== null && curr !== "") {
        return curr;
      }
    } catch(e) { }
    try {
      let curr = window.meta.page.customerId;
      if (curr !== undefined && curr !== null && curr !== "") {
        return curr;
      }
    } catch (e) { }    
    try {
      let curr = _st.cid;
      if (curr !== undefined && curr !== null && curr !== "") {
        return curr;
      }
    } catch (e) { }
    try {
      let curr = ShopifyAnalytics.lib.user().traits().uniqToken;
      if (curr !== undefined && curr !== null && curr !== "") {
        return curr;
      }
    } catch (e) { }
    return null;
  }


  var shouldSendToSubscriptions = false;
  var shouldLoginByToken = false;
  var curCustomerId = getCustomerId();
  //if (window.ShopifyAnalytics.meta.page.customerId > 0){
  if (curCustomerId > 0){
    var hasActiveSubscriptionElem = document.getElementById("hasActiveSubscription");
    if (hasActiveSubscriptionElem != undefined && hasActiveSubscriptionElem.value == "true"){
      if (window.location.href.indexOf('collections/subscriptions') > -1){
          var tempStr = window.location.href.replace('collections/subscriptions','collections/screens');
          window.location = tempStr;
      }
      shouldLoginByToken = true;
    }
    else {
      shouldSendToSubscriptions = true;
    }
  }
  else {
    shouldSendToSubscriptions = true;
  }
  if (shouldSendToSubscriptions && window.location.href.indexOf('collections/screens') > -1){
    var tempStr = window.location.href.replace('collections/screens','collections/subscriptions');
    window.location = tempStr;
  }
  if (shouldLoginByToken && window.location.href.indexOf('/account') > -1){
    debugger;
    const tokenSaved = getCookie('token');
    if (tokenSaved){
      console.log(tokenSaved);
      //$.post("https://negah.iranproud2.net/api/shopifycustomerloginbytoken",
      //$.post("https://negah.negahestan.com/api/shopifycustomerloginbytoken",
      $.post("https://negahold.negahestan.com/api/shopifycustomerloginbytoken",
      {
        //tags: $("#namaPinCodeSet").val()
        id: curCustomerId,
        token: tokenSaved
      },
      function(data, status){
        alert("Status: " + status);
        //alert("Data: " + data + "\nStatus: " + status);
      });
      deleteCookie("token");
    }
  }

  

$("#accountProfilePage").click(function(){
  $("#accountProfilePage").removeClass("selected-tab-menu");
  $("#accountOrdersPage").removeClass("selected-tab-menu");
  $("#accountSubscriptionsPage").removeClass("selected-tab-menu");
  $("#accountProfilePage").addClass("selected-tab-menu");

  $("#accountInfoDiv").removeClass("not-selected-tab-menu");  
  $("#orderHistoryDiv").removeClass("not-selected-tab-menu");
  $("#subscriptionInfoDiv").removeClass("not-selected-tab-menu");
  $("#orderHistoryDiv").addClass("not-selected-tab-menu");
  $("#subscriptionInfoDiv").addClass("not-selected-tab-menu");
  return false;
});
$("#accountOrdersPage").click(function(){
  $("#accountProfilePage").removeClass("selected-tab-menu");
  $("#accountOrdersPage").removeClass("selected-tab-menu");
  $("#accountSubscriptionsPage").removeClass("selected-tab-menu");
  $("#accountOrdersPage").addClass("selected-tab-menu");

  $("#accountInfoDiv").removeClass("not-selected-tab-menu");  
  $("#orderHistoryDiv").removeClass("not-selected-tab-menu");
  $("#subscriptionInfoDiv").removeClass("not-selected-tab-menu");
  $("#accountInfoDiv").addClass("not-selected-tab-menu");
  $("#subscriptionInfoDiv").addClass("not-selected-tab-menu");
  return false;
});
$("#accountSubscriptionsPage").click(function(){
  $("#accountProfilePage").removeClass("selected-tab-menu");
  $("#accountOrdersPage").removeClass("selected-tab-menu");
  $("#accountSubscriptionsPage").removeClass("selected-tab-menu");
  $("#accountSubscriptionsPage").addClass("selected-tab-menu");

  $("#accountInfoDiv").removeClass("not-selected-tab-menu");  
  $("#orderHistoryDiv").removeClass("not-selected-tab-menu");
  $("#subscriptionInfoDiv").removeClass("not-selected-tab-menu");
  $("#accountInfoDiv").addClass("not-selected-tab-menu");
  $("#orderHistoryDiv").addClass("not-selected-tab-menu");
  return false;
});

$("#loginBtn").click(function(){
  //$.post("http://negah.iranproud2.net:8010/authorize.aspx",
  $.post("http://negah.negahestan.com:8010/authorize.aspx",
  {
    name: "Donald Duck",
    city: "Duckburg"
  },
  function(data, status){
    alert("Data: " + data + "\nStatus: " + status);
  });
});

$("#registerBtn").click(function(){
  //$.post("http://negah.iranproud2.net:8010/authorize.aspx",
  $.post("http://negah.negahestan.com:8010/authorize.aspx",
  {
    name: "Donald Duck",
    city: "Duckburg"
  },
  function(data, status){
    alert("Data: " + data + "\nStatus: " + status);
  });
});

